import { z } from "zod";

import { Environment } from "@abacus/common";

import { JobName } from "./types";

export const neo4jDBSchema = z.string().default("graph.db");
export const neo4jHostSchema = z
  .string()
  .default("neo4j-cluster.theorchard.io");
export const neo4jPassSchema = z.string().optional();
export const neo4jPortSchema = z.coerce.number().int().min(0).default(7687);
export const neo4jUserchema = z.string().optional();

export const envSchema = z.object({
  APPLICATION_NAME: z.string().default("costco"),
  CHUNK_SIZE: z.coerce.number().int().min(1).default(16),
  ENVIRONMENT: z.nativeEnum(Environment).default(Environment.Dev),
  INPUT_PATH: z.string().default("./input.json"),
  MAX_WORKERS: z.coerce.number().int().min(1).max(64).default(16),
  // Neo4J
  NEO4J_ENV_DB: neo4jDBSchema,
  NEO4J_ENV_HOST: neo4jHostSchema,
  NEO4J_ENV_PASS: neo4jPassSchema,
  NEO4J_ENV_PORT: neo4jPortSchema,
  NEO4J_ENV_USER: neo4jUserchema,
  NEO4J_PROD_DB: neo4jDBSchema,
  NEO4J_PROD_HOST: neo4jHostSchema,
  NEO4J_PROD_PASS: neo4jPassSchema,
  NEO4J_PROD_PORT: neo4jPortSchema,
  NEO4J_PROD_USER: neo4jUserchema,
  OUTPUT_PATH: z.string().default("./output.json"),
  // Auth
  ORCHARD_IDENTITY_ID: z.string(),
  // AWS
  AWS_ACCESS_KEY_ID: z.string(),
  AWS_PROFILE: z.string().optional(),
  AWS_SECRET_ACCESS_KEY: z.string(),
  AWS_SESSION_TOKEN: z.string(),
  AWS_REGION: z.string().default("us-east-1"),
  // Snowflake
  SNOWFLAKE_ACCOUNT: z.string().default("orchard"),
  SNOWFLAKE_DATABASE: z.string().default("ORCHARD_APP_REPORTING_V2"),
  SNOWFLAKE_HOST: z.string().default("orchard.snowflakecomputing.com"),
  SNOWFLAKE_KEY_PASS: z.string().optional(),
  SNOWFLAKE_PRIVATE_KEY_PATH: z.string().optional(),
  SNOWFLAKE_ROLE: z.string().default("DEV_ENGINEERING"),
  SNOWFLAKE_USER: z.string().optional(),
  SNOWFLAKE_WAREHOUSE: z.string().default("DEV_OWS_WAREHOUSE"),
  // Throttle
  THROTTLE_DURATION: z.coerce.number().int().min(0).default(1000),
  THROTTLE_LIMIT: z.coerce.number().int().min(1).default(16),
});

export const jobNameSchema = z.nativeEnum(JobName);

export const jobRequestSchema = z.object({
  job: jobNameSchema,
  config: z.object({}).passthrough().optional(),
  data: z.object({}).passthrough().optional(),
});
